import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackUnsubscribeAllPreferences, trackUpdatePreferences } from 'unsubscribe-ui/data/TrackingEvents';
import Spacer from 'unsubscribe-ui/components/core/layout/Spacer';
import PrimaryButton from 'unsubscribe-ui/components/core/buttons/PrimaryButton';
import SecondaryButton from 'unsubscribe-ui/components/core/buttons/SecondaryButton';
import Flex from 'unsubscribe-ui/components/core/layout/Flex';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreferencesAction = ({
  onClickManagePreference,
  onClickUnsubscribeAll
}) => {
  const handleClickSavePreferences = async () => {
    trackUpdatePreferences();
    await (onClickManagePreference === null || onClickManagePreference === void 0 ? void 0 : onClickManagePreference());
  };
  const handleClickUnsubscribeAllPreferences = async () => {
    trackUnsubscribeAllPreferences();
    await (onClickUnsubscribeAll === null || onClickUnsubscribeAll === void 0 ? void 0 : onClickUnsubscribeAll());
  };
  return /*#__PURE__*/_jsxs(Flex, {
    align: "left",
    justify: "left",
    padding: "1.5rem 0",
    children: [/*#__PURE__*/_jsx(PrimaryButton, {
      onClick: handleClickSavePreferences,
      "data-test-id": "save-preferences",
      loadingText: I18n.text('preferences.savingPreferences'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "preferences.save"
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      paddingInline: "200"
    }), /*#__PURE__*/_jsx(SecondaryButton, {
      onClick: handleClickUnsubscribeAllPreferences,
      "data-test-id": "unsubscribe-all",
      loadingText: I18n.text('preferences.unsubscribingAll'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "preferences.unsubscribeAll"
      })
    })]
  });
};
export default PreferencesAction;